export default {
	methods: {
		mixin_autoResize_resize(event) {
			event.target.style.height = "50px";
			event.target.style.height = `${event.target.scrollHeight}px`;
		}
	},
};
